export const GIP_PRODUCTS_NAME: any = {
    "momento" : "Momento",
    "proxima": "Próxima",
    "proximaPlus": "Próxima Plus",
    "integral100k" : "Integral 100.000",
    "integral180k" : "Integral 180.000",
    "integral240k" : "Integral 240.000"
};